import ShopeeImg from './assets/channel/shopee.svg';
import LazadaImg from './assets/channel/lazada.svg';
import TiktokImg from './assets/channel/tiktok.svg';
import TokopediaImg from './assets/channel/tokopedia.svg';
import WhatsappImg from './assets/channel/whatsapp.svg';
import MercadoImg from './assets/channel/mercado.svg';
import KwaiImg from './assets/channel/kwai.svg';
import FacebookImg from './assets/channel/facebook.svg';
import { HTMLAttributes, useState } from 'react';

const ChannelIconMap: Record<Conversation.Conversation['channel'], string> = {
  SHOPEE: ShopeeImg,
  LAZADA: LazadaImg,
  TIKTOK: TiktokImg,
  TIKTOK_US: TiktokImg,
  TOKOPEDIA: TokopediaImg,
  WA_BIZ: WhatsappImg,
  ALIEXPRESS: '',
  MERCADO: MercadoImg,
  KWAI: KwaiImg,
  FACEBOOK: FacebookImg,
};

interface ChannelIconProps extends HTMLAttributes<HTMLImageElement> {
  channel: Conversation.Conversation['channel'];
}

export const ChannelIcon = (props: ChannelIconProps) => {
  const { channel, ...rest } = props;
  const [isError, setIsError] = useState(false);

  if (isError) {
    return null;
  }

  const handleError = () => {
    setIsError(true);
  };

  return <img {...rest} src={ChannelIconMap[channel]} alt={channel} onError={handleError} />;
};
